import { Injectable, inject, provideAppInitializer } from '@angular/core';
import { EcaEnvironmentService } from '../environment/environment.service';
import { JQUERY_TOKEN } from '../jquery-provider/jquery-provider';

@Injectable({
  providedIn: 'root'
})
export class EcaPortalHeaderLibLoaderService {
  private _jQuery = inject(JQUERY_TOKEN);
  private _ecaEnvironmentService = inject(EcaEnvironmentService);


  load(): Promise<any> {
    return this._ecaEnvironmentService.load().then((env) => {
      if (env.portalHeaderLibUrl) {
        const jQueryPromise = (this._jQuery as any).getScript(env.portalHeaderLibUrl);
        return Promise.resolve(jQueryPromise);
      }
    });
  }
}

export function loadPortalHeaderLibFactory (ecaPortalHeaderLibLoaderService: EcaPortalHeaderLibLoaderService) {
  return () => ecaPortalHeaderLibLoaderService.load();
}

export const ECA_PORTAL_HEADER_LOADER_APP_INITIALIZER_PROVIDER = provideAppInitializer(() => {
        const initializerFn = (loadPortalHeaderLibFactory)(inject(EcaPortalHeaderLibLoaderService));
        return initializerFn();
      });
